export default __webpack_public_path__ + "static/media/YAS0140.34I-27626_-17220_0.f9c32f6a.jpg";